import { render, staticRenderFns } from "./PipelinePrepPlaster.vue?vue&type=template&id=04b25901&scoped=true&"
import script from "./PipelinePrepPlaster.vue?vue&type=script&lang=js&"
export * from "./PipelinePrepPlaster.vue?vue&type=script&lang=js&"
import style0 from "./PipelinePrepPlaster.vue?vue&type=style&index=0&id=04b25901&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b25901",
  null
  
)

export default component.exports